<template>
    <div>
        <div class="d-flex justify-content-center card-intro text-center mb-4">
            <div class="" style="width: 100%; max-width: 500px;">
                <h1 class="text-32 text-center">See if Wondr is available at no cost to you.</h1>
                <p class="pt-2">Enter your information below, and we'll check to see if your employer or health plan offers Wondr as part of your benefits package. If so, you'll be directed to your enrollment page.</p>
            </div>
        </div>
        <form class="form-floating-labels" @submit.stop.prevent="submitForm">
            <div class="d-flex justify-content-center card-form">
                <div style="width: 100%; max-width: 300px;">
                    <div class="form-group" style="margin-bottom: 32px;">
                        <label for="first_name">First Name</label>
                        <input
                            type="text"
                            id="first_name"
                            placeholder="First Name"
                            aria-describedby="First Name"
                            tabindex="1"
                            class="form-control form-control-lg fl-input"
                            :class="{ 'is-invalid': errors.first_name }"
                            data-placeholder="First Name"
                            @input="updateField('first_name', $event.target.value)"
                            :value="first_name"
                            @keydown="errors.first_name = false"
                        >
                        <p class="mt-1 mb-0 small text-danger" v-if="errors.first_name">
                            Please enter your first name.
                        </p>
                    </div>
                    <div class="form-group" style="margin-bottom: 32px;">
                        <label for="last_name">Last Name</label>
                        <input
                            type="text"
                            id="last_name"
                            placeholder="Last Name"
                            aria-describedby="Last Name"
                            tabindex="1"
                            class="form-control form-control-lg fl-input"
                            :class="{ 'is-invalid': errors.last_name }"
                            data-placeholder="Last Name"
                            @input="updateField('last_name', $event.target.value)"
                            :value="last_name"
                            @keydown="errors.last_name = false"
                        >
                        <p class="mt-1 mb-0 small text-danger" v-if="errors.last_name">
                            Please enter your last name.
                        </p>
                    </div>
                    <div class="form-group" style="margin-bottom: 32px;">
                        <label for="field_email">Email Address</label>
                        <input
                            type="email"
                            id="field_email"
                            placeholder="Email Address"
                            aria-describedby="Email"
                            tabindex="2"
                            class="form-control form-control-lg fl-input"
                            :class="{ 'is-invalid': errors.email }"
                            data-placeholder="Email Address"
                            @input="updateField('email', $event.target.value)"
                            :value="email"
                            @keydown="errors.email = false"
                        >
                        <p class="mt-1 mb-0 small text-danger" v-if="errors.email">
                            Please enter your email.
                        </p>
                    </div>
                    <div class="form-group" style="margin-bottom: 56px;">
                        <div style="position: relative;">
                            <label for="employer_name">Search Employer Name</label>
                            <input
                                type="text"
                                id="employer_name"
                                placeholder="Search Employer Name"
                                aria-describedby="Search Employer Name"
                                tabindex="3"
                                class="form-control form-control-lg fl-input"
                                :class="{ 'is-invalid': errors.employer }"
                                :style="employerStyle"
                                data-placeholder="Search Employer Name"
                                @input="debounceSearch"
                                @focus="debounceSearch"
                                ref="employer"
                                @keydown="errors.employer = false"
                            >
                            <p class="mt-1 mb-0 small text-danger" v-if="errors.employer">
                                Please enter your employer name.
                            </p>
                            <div v-show="employers.length" class="dropdown-list" v-click-outside="onClickOutside">
                                <div
                                    v-for="item in employers"
                                    :key="item.name"
                                    class="dropdown-item"
                                    @click="selectEmployer(item)"
                                    style="cursor: pointer;"
                                >
                                    {{ item.value }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <p>
                        <button
                            type="submit"
                            id="corplanding_lookup_button"
                            :disabled="loading || incomplete"
                            class="btn btn-primary-light shadow btn-block"
                            v-html="submitButton"
                        >
                        </button>
                    </p>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    name: 'eligibility-search',
    props: [
        'first_name',
        'last_name',
        'email'
    ],
    data(){
        return {
            employer_search: '',
            employers: [],
            employer_selected: null,
            loading: false,
            typing: null,
            debounce: null,
            errors: {
                first_name: false,
                last_name: false,
                email: false,
                employer: false
            }
        }
    },
    mounted(){
        new FloatLabels( "form.form-floating-labels", { exclude: ".no-floating-label" });
    },
    computed: {
        incomplete(){
            return this.first_name.length === 0 || this.last_name.length === 0 || this.email.length === 0 || this.employer_search.length === 0;
        },
        submitButton(){
            return this.loading ? `<img src="${VUE_APP_LMS}/imgD/spinner-small-white.svg" style="height: 1rem;">` : "Check";
        },
        employerStyle(){
            return {
                'border-bottom-left-radius': this.employers.length ? 0 : '8px',
                'border-bottom-right-radius': this.employers.length ? 0 : '8px',
            }
        }
    },
    methods: {
        updateField(field, value){
            this.$emit('updateField', {field, value});
        },
        onClickOutside(){
            if (this.employers.length){
                this.employers = [];
            }
        },
        validateForm(){
            let isValid = true;
            if (this.first_name.length === 0){
                this.errors.first_name = true;
                isValid = false;
            }
            if (this.last_name.length === 0){
                this.errors.last_name = true;
                isValid = false;
            }
            if (this.email.length === 0){
                this.errors.email = true;
                isValid = false;
            }
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if ((this.email!='')&&(!re.test(String(this.email).toLowerCase()))){
                this.errors.email = true;
                isValid = false;
            }
            if (this.employer_search.length === 0){
                this.errors.employer = true;
                isValid = false;
            }
            return isValid;
        },
        submitForm(){
            if (!this.validateForm()) return;
            this.loading = true;
            axios.post('/Save_Employer_Search',{
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email,
                company_name: this.$refs.employer.value
            }).then( ({data}) => {
                // console.log(data);
                if (data && data.success){
                    // console.log('pushing gtm event');
                    dataLayer.push({'event': 'corplanding_lookup_complete'});
                    if (data.shortcut_URL && data.shortcut_URL.length) {
                        window.location.href = data.shortcut_URL;
                    } else {
                        this.$router.push({ name: 'results' });
                        this.loading = false;
                    }
                } else {
                    this.showError();
                    this.loading = false;
                }
            }).catch( e => {
                this.showError();
                this.loading = false;
            });
        },
        showError(message){

        },
        debounceSearch(event) {
            if (event.target.value === '') {
                this.employers = [];
                this.employer_selected = null;
            }
            this.employer_search = '';
            this.typing = 'You are typing'
            clearTimeout(this.debounce)
            this.debounce = setTimeout(() => {
                this.typing = null
                this.employer_search = event.target.value
                this.search();
            }, 300)
        },
        search(){
            if (this.employer_search === '') return;
            axios.post('/Employer_Search', {
                company_name: this.employer_search
            }).then( r => {
                if (r && r.data && r.data.matches){
                    this.employers = [];
                    if (r.data.match_count === 0){
                        return;
                    }
                    Object.keys(r.data.matches).forEach( key => {
                        this.employers.push({
                            id: key,
                            value: r.data.matches[key]
                        });
                    });
                }
            });
        },
        selectEmployer(employer){
            this.employers = [];
            this.$refs.employer.value = employer.value;
            this.employer_search = employer.value;
            this.employer_selected = employer;
        }
    }
}
</script>

<style>
.dropdown{
    position: relative;
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
}
.dropdown-input, .dropdown-selected{
    width: 100%;
    padding: 10px 16px;
    border: 1px solid transparent;
    background: #edf2f7;
    line-height: 1.5em;
    outline: none;
    border-radius: 8px;
}
.dropdown-input:focus, .dropdown-selected:hover{
    background: rgb(248 236 255);
}
.dropdown-input::placeholder{
    opacity: 0.7;
}
.dropdown-selected{
    font-weight: bold;
    cursor: pointer;
}
.dropdown-list{
    position: absolute;
    max-height: 500px;
    overflow-y: auto;
    background: #F4F3F5;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    z-index:100;
    overflow-x: visible;
    width: auto;
    min-width:100%;
}
.dropdown-item{
    display: flex;
    padding: 11px 16px;
    cursor: pointer;
    color: #001523;
    width: 100%;
}
.dropdown-item:hover {
    background-color: rgb(248 236 255);
}
.dropdown-item:active{
    color: #6a3ac0;
    background-color: rgb(248 236 255);
}
.dropdown-item-flag{
    max-width: 24px;
    max-height: 18px;
    margin: auto 12px auto 0px;
}
</style>